module.exports = __webpack_public_path__ + "static/assets/54548b8a081f5ada6823bf64a08f34d4.gif";